import PropTypes from 'prop-types'
import React, { useState, useCallback } from 'react'
import ImageCarousel from 'components/pdp/carousel-images/image-carousel/ImageCarousel'
import CarouselHeroImage from './carousel-hero-image/CarouselHeroImage'
import ShopTheLook from './shop-the-look'
import CarouselThumbnailList from './thumbnails-list'

const LegacyProductCarouselImages = ({
  id,
  images,
  isPhone,
  isShownShopTheLook,
  phone,
  shopLookCtaEventTracking,
  video,
  is_italist,
  isOpenVirtualTryOn,
  virtual_try_on_enabled,
}) => {
  const [currentIdx, setCurrentIdx] = useState(0)
  const onIntersect = useCallback((idx) => setCurrentIdx(idx), [])

  if (!images?.length) {
    return null
  }

  let data = [...images]
  const lastIdx = images.length - 1
  const isHidden = currentIdx === lastIdx

  if (Object.keys(video).length) {
    data = [...images, video]
  }

  if (phone || isPhone) {
    const handleClickSwipe = () => {
      const pdpImagesScrollPoint = document.getElementById(
        'pdp__carousel-images-swipe-up-bar',
      )
      const yOffset = -44
      const yPosition =
        pdpImagesScrollPoint.getBoundingClientRect().top +
        window.scrollY +
        yOffset

      window.scrollTo({
        top: yPosition,
        behavior: 'smooth',
      })
    }

    return (
      <div className="pdp__carousel-images">
        <ImageCarousel
          id={id}
          isPhone
          video={video}
          images={images}
          is_italist={is_italist}
          onLastImageSwipeUp={handleClickSwipe}
          isOpenVirtualTryOn={isOpenVirtualTryOn}
          isShownShopTheLook={isShownShopTheLook}
          virtual_try_on_enabled={virtual_try_on_enabled}
          shopLookCtaEventTracking={shopLookCtaEventTracking}
        />
      </div>
    )
  }

  return (
    <div className="pdp__carousel-images">
      <div className="pdp__carousel-thumbnails">
        <CarouselThumbnailList images={data} currentIdx={currentIdx} />
      </div>
      <div className="pdp__carousel-hero-img">
        <div className="pdp__carousel-hero-img__wrapper">
          {data.map((img, idx) => (
            <CarouselHeroImage
              key={img.full_path || img.full_cover_image_path}
              img={img}
              productId={id}
              idx={idx}
              onIntersect={onIntersect}
              is_italist={is_italist}
            />
          ))}
          {isShownShopTheLook && !isHidden && (
            <ShopTheLook
              productId={id}
              shopLookCtaEventTracking={shopLookCtaEventTracking}
            />
          )}
        </div>
      </div>
    </div>
  )
}

LegacyProductCarouselImages.defaultProps = {
  isShownShopTheLook: false,
  phone: false,
  shopLookCtaEventTracking: null,
  video: {},
  is_italist: false,
  isOpenVirtualTryOn: false,
  virtual_try_on_enabled: false,
}

LegacyProductCarouselImages.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      full_path: PropTypes.string,
    }),
  ).isRequired,
  isPhone: PropTypes.bool.isRequired,
  is_italist: PropTypes.bool,
  isShownShopTheLook: PropTypes.bool,
  phone: PropTypes.bool,
  shopLookCtaEventTracking: PropTypes.func,
  video: PropTypes.shape({
    video_path: PropTypes.string,
    cover_image_path: PropTypes.string,
  }),
  isOpenVirtualTryOn: PropTypes.bool,
  virtual_try_on_enabled: PropTypes.bool,
}

export default LegacyProductCarouselImages
